import { useJourneysData2 } from './useJourneysData2'

const useJourneysDataFetch = () => {
  const {
    routes,
    setRoutes,
    userRoutes,
    journeys,
    setJourneys,
    setRawJourneys,
    addAirJourney,
    updateAirJourney,
    updateJourneys,
    setUpListeners,
    drawJourneys,
    drawJourneyHistories,
  } = useJourneysData2()

  return {
    routes,
    setRoutes,
    userRoutes,
    journeys,
    setJourneys,
    setRawJourneys,
    addAirJourney,
    updateAirJourney,
    updateJourneys,
    setUpListeners,
    drawJourneys,
    drawJourneyHistories,
  }
}

export default useJourneysDataFetch
